import { render, staticRenderFns } from "./PassBox.vue?vue&type=template&id=610bd3c2&scoped=true&"
import script from "./PassBox.vue?vue&type=script&lang=js&"
export * from "./PassBox.vue?vue&type=script&lang=js&"
import style0 from "./PassBox.vue?vue&type=style&index=0&id=610bd3c2&prod&lang=scss&"
import style1 from "./PassBox.vue?vue&type=style&index=1&id=610bd3c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610bd3c2",
  null
  
)

export default component.exports